import { Grid, useEventCallback } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import { PmiButton } from 'shell/components/shared/button';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import {
  ResearchRegisterVM,
  ResearchRegisterFilterVM,
} from 'practice/view-models/research-register';

const FormFilter = (): React.ReactElement => {
  const formContext = useFormikContext<ResearchRegisterVM>();

  const onChange = useEventCallback(
    (
      key: keyof ResearchRegisterFilterVM,
      value: ResearchRegisterFilterVM[keyof ResearchRegisterFilterVM]
    ) => {
      formContext.setFieldValue('filter', {
        ...(formContext.values?.filter || {}),
        [key]: value,
      });
    }
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Tipo registro"
          aria-label="Tipo registro"
          fullWidth
          id="typeRegister"
          name="typeRegister"
          value={formContext.values.filter?.typeRegister || ''}
          onChange={(event) => onChange('typeRegister', event.target.value)}
          error={
            (formContext.touched.filter as FormikTouched<ResearchRegisterFilterVM>)?.typeRegister &&
            Boolean(
              (formContext.errors.filter as FormikErrors<ResearchRegisterFilterVM>)?.typeRegister
            )
          }
          helperText={
            (formContext.errors.filter as FormikErrors<ResearchRegisterFilterVM>)?.typeRegister
          }
          inputProps={{
            maxLength: '8',
          }}
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          label="Descrizione registro"
          aria-label="Descrizione registro"
          fullWidth
          id="description"
          name="description"
          value={formContext.values.filter?.description || ''}
          onChange={(event) => onChange('description', event.target.value)}
          error={
            (formContext.touched.filter as FormikTouched<ResearchRegisterFilterVM>)?.description &&
            Boolean(
              (formContext.errors.filter as FormikErrors<ResearchRegisterFilterVM>)?.description
            )
          }
          helperText={
            (formContext.errors.filter as FormikErrors<ResearchRegisterFilterVM>)?.description
          }
          inputProps={{
            maxLength: '50',
          }}
        />
      </Grid>
      <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
        <Grid item xs={12} md={2}>
          <PmiButton variant="contained" color="secondary" fullWidth type="submit">
            Cerca
          </PmiButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

FormFilter.displayName = 'Form Filter';

export default FormFilter;
